<template>
  <div id="loading" ref="loadingOverlay">
    <div class="overlay"></div>
    <lottie
      id="bm-loading"
      :options="defaultOptions"
      v-on:animCreated="handleAnimation"
    />
    <span></span>
  </div>
</template>

<script>
import Lottie from '@/bm/lottie.vue';
import * as animationData from '@/bm/logo/data.json';

export default {
  name: 'loading',
  components: {
    'lottie': Lottie
  },
  data() {
    return {
      defaultOptions: {animationData: animationData.default, loop: false},
      animationSpeed: 1,
      NavNum: 0,
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    handleAnimation: function (anim) {
      this.anim = anim;
    },

    stop: function () {
      this.anim.stop();
    },

    play: function () {
      this.anim.play();
    },

    pause: function () {
      this.anim.pause();
    },

    onSpeedChange: function () {
      this.anim.setSpeed(this.animationSpeed);
    }
  },
  mounted() {
    setTimeout(() => {
      this.close()
    }, 5200)

    this.$refs.loadingOverlay.classList.add('active')
  }
}
</script>
